import { cx } from 'class-variance-authority';
import { FC, PropsWithChildren } from 'react';

export type ProjectNavIconProps = PropsWithChildren<{
  active?: boolean;
}>;

export const ProjectNavIcon: FC<ProjectNavIconProps> = (props) => {
  return (
    <div
      className={cx(
        'h-10 w-10 shrink-0 cursor-pointer border-b border-black-20 p-2 text-white-60 transition-colors hover:bg-white-4 hover:text-white',
        {
          'bg-white-4': !!props.active,
        }
      )}
    >
      {props.children}
    </div>
  );
};
